'use client'

import { navigateToPage } from '@marketplace-web/browser/browser-navigation-util'
import { useTracking } from '@marketplace-web/observability/event-tracker-data'
import { clickContactUsButtonEvent } from '@marketplace-web/help-center-conversation-support/conversational-chatbot-data'
import { ConversationActionProps } from '@marketplace-web/messaging/conversation-action-data'
import { ConversationActionButton } from '@marketplace-web/messaging/conversation-action-feature'
import useHelpCenterSessionTracking from '@marketplace-web/help-center/help-center-session-tracking-util'

import { urlWithParams } from '@marketplace-web/shared/utils'
import { useConversationContext } from '@marketplace-web/messaging/conversation-providers-feature'

import { NEW_HELP_TICKET_URL } from '../../constants/routes'

type Props = ConversationActionProps

const CONVERSATIONAL_CHATBOT_FAQ_ID = 1514

const ContactVintedSupport = ({ primary, title, inverse, theme, size }: Props) => {
  const { track } = useTracking()
  const { helpCenterSessionId } = useHelpCenterSessionTracking()
  const { conversation } = useConversationContext()
  const conversationId = conversation?.id

  const trackButtonClick = () => {
    if (!helpCenterSessionId || !conversationId) return
    const eventParams = {
      helpCenterSessionId,
      threadId: conversationId?.toString(),
    }
    track(clickContactUsButtonEvent(eventParams))
  }

  const handleButtonClick = () => {
    const pageUrl = urlWithParams(NEW_HELP_TICKET_URL, {
      faq_entry_id: CONVERSATIONAL_CHATBOT_FAQ_ID,
      allow_direct: 1,
      related_only: false,
      thread_id: conversationId?.toString(),
    })
    trackButtonClick()
    navigateToPage(pageUrl)
  }

  return (
    <ConversationActionButton
      primary={primary}
      text={title}
      size={size}
      inverse={inverse}
      theme={theme}
      onClick={handleButtonClick}
    />
  )
}

export default ContactVintedSupport
